import { MODULE_NAME as ACCOUNTS_MODULE } from 'modules/accounts/config/routes/module';
import * as FIELDS from '../../fields';
import { REPORT_PRESET } from '../../pickers';
import { ACCOUNT_LIST_REPORT_ID } from './accountListReportId';
import { columnDefinitions } from './columnDefinitions';
import { defaultColumns } from './reportPresets';

export const accountListReportConfig = {
    id: ACCOUNT_LIST_REPORT_ID,
    label: 'Account List',
    module: ACCOUNTS_MODULE,
    endpoint: 'accounts',
    rowIdField: FIELDS.ACCOUNT_ID.field,
    columnsDef: columnDefinitions,
    presets: {
        [REPORT_PRESET.DEFAULT]: { columns: defaultColumns },
    },
    searchPlaceholderMsgId: 'app.reports.account-list.search.placeholder',
    searchField: 'search',
};
